module.exports = __webpack_public_path__ + "assets/img/prd3-4.1250bc0c.jpg";